export default __webpack_public_path__ + "e1dea7335f9f0ef31af5e4236545f63f.svg";